export default "__VITE_ASSET__Cs$1pFO$__"